import React, { useState, useEffect } from "react";
import AppLoader from "../AppLoader";
import Container from "@material-ui/core/Container";
import { useAuth0 } from "../../react-auth0-spa";
import { InlineWidget } from "react-calendly";
import { useLocation } from "react-router-dom";
import Alert from "@material-ui/lab/Alert";

function titleCase(str) {
  var splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr.join(" ");
}

const buildCalendlyUrl = (lessonType, user, couponCode) => {
  let url = "https://calendly.com/julieth-spanish";
  const querystring = [];

  if (lessonType && lessonType !== ":lessonType") {
    url = `${url}/${lessonType}`;
  }

  if (user.email && user.name) {
    const name = user.name.split("@")[0];
    querystring.push(`email=${user.email}`);
    querystring.push(`name=${titleCase(name)}`);
  }

  if (couponCode) {
    querystring.push(`a1=${couponCode}`);
  }

  url = `${url}?${querystring.join("&")}`;

  return url;
};

export default function Calendly(props) {
  const { state } = useLocation();
  const { user } = useAuth0();
  const {
    match: { params },
  } = props;
  let { lessonType } = params;

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const head = document.querySelector("head");
    const script = document.createElement("script");
    script.setAttribute(
      "src",
      "https://assets.calendly.com/assets/external/widget.js"
    );
    script.addEventListener("load", () => {
      setLoading(false);
    });
    head.appendChild(script);
  });

  if (loading) {
    return <AppLoader />;
  }

  let couponCode = "";

  if (state && state.state && state.state.couponCode) {
    couponCode = state.state.couponCode;
    lessonType = state.state.couponData.secretLinkPath;
  }

  const calendlyUrl = buildCalendlyUrl(lessonType, user, couponCode);

  return (
    <Container maxWidth="lg">
      {state && state.state && state.state.couponCode && (
        <Alert style={{ marginTop: "25px" }} severity="success">
          <p>
            You are booking a{" "}
            <strong>{state.state.couponData.prettyName}</strong> using the
            coupon code: <strong>{state.state.couponCode}</strong>
          </p>
        </Alert>
      )}
      <InlineWidget
        url={calendlyUrl}
        styles={{
          height: "1000px",
        }}
        utm={{
          utmCampaign: "Generic",
          utmContent: couponCode,
          utmMedium: "Organic",
          utmSource: "Bookings Dashboard",
          utmTerm: "",
        }}
      />
    </Container>
  );
}

// export default Calendly;
